import React from 'react';
import FormInput from 'components/FormInput';

const NameStep = () => (
  <>
    <FormInput
      label='Voornaam *'
      id='firstname'
      placeholder='Kees'
    />
    <FormInput
      label='Tussenvoegsel'
      id='insertion'
      placeholder='van der'
    />
    <FormInput
      label='Achternaam *'
      id='lastname'
      placeholder='Broek'
    />
  </>
);

export default NameStep;
